var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('footer',[_vm._v(" © 2020 Cüneyt Aliustaoğlu ")])
}
var staticRenderFns = []

export { render, staticRenderFns }